import type { PublicSlotKey } from '#packages/apilib';
import type { BlocksApi } from './blocksApi';

export const BlocksApiKey: PublicSlotKey<BlocksApi> = {
  name: 'BlocksApi',
  public: true,
};
